import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AppLayout() {
  return (
    <div className="min-h-screen flex bg-[#F5F9FD] text-slate-100">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 lg:pl-64 bg-[#F5F9FD] bg-[#F5F9FD]">
        <Topbar />
        <main className="flex-1 p-4 sm:p-6 lg:p-7 max-w-[1600px] w-full mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
